export const CONSTANT_SMS_SIZE = 67

export const smTabs = [
  { name: 'batchSM', label: '群发短信', slot: 'batchSM' },
  { name: 'batchRecord', label: '群发记录', slot: 'batchRecord' },
  { name: 'alreadySM', label: '已发短信', slot: 'alreadySM' }
]

// 已发短信状态
export const sendState = {
  SEND_SENDING: 0, // 发送中
  SEND_SUCCESS: 1, //发送成功
  SEND_ERROR: 2 // 发送失败
}

export const sendStatus = [
  {
    label: '发送中',
    value: sendState.SEND_SENDING,
    color: '#E8A31B'
  },
  {
    label: '发送成功',
    value: sendState.SEND_SUCCESS,
    color: '#00BE6A'
  },
  { label: '发送失败', value: sendState.SEND_ERROR, color: '#E34152' }
]

export const answerStatus = {
  3: { label: '正在答题', color: '#2775E8' },
  0: { label: '待质控', color: '#E8A31B' },
  1: { label: '质控通过', color: '#00BE6A' },
  2: { label: '质控拒绝', color: '#E34152' },
  4: { label: '被甄别', color: '#2775E8' },
  5: { label: '超时', color: '#E8A31B' },
  6: { label: '超额', color: '#E34152' },
  10: { label: '质控驳回', color: '#E8A31B' },
  11: { label: '已终止', color: '#E34152' },
  12: { label: '处理中', color: '#E8A31B' }
}

// 群发记录状态
export const groupState = {
  GROUP_UNPAID: 0, // 未支付
  GROUP_SENDING: 1, // 发送中
  GROUP_ERROR: 2, //发送失败
  GROUP_SUCCESS: 3 // 发送成功
}

export const groupStatus = {
  [groupState.GROUP_UNPAID]: { label: '未支付', color: '' },
  [groupState.GROUP_SENDING]: {
    label: '发送中',
    color: '#E8A31B'
  },
  [groupState.GROUP_ERROR]: { label: '发送失败', color: '#E34152' },
  [groupState.GROUP_SUCCESS]: { label: '发送完成', color: '#00BE6A' }
}

export const brColumns = [
  {
    label: '批次编号',
    value: 'id',
    width: '100px'
  },
  {
    label: '模板内容',
    value: 'templateContent',
    width: '260px'
  },
  {
    label: '发送人数',
    value: 'sendSampleCount',
    width: '70px'
  },
  {
    label: '回收数量',
    value: 'recycleNumber',
    width: '70px'
  },
  {
    label: '费用（元）',
    value: 'totalAmount',
    width: '70px'
  },
  {
    label: '发送时间',
    value: 'sendTime',
    width: '120px'
  },
  {
    label: '状态',
    value: 'status',
    width: '70px'
  },
  {
    label: '操作',
    value: 'action',
    width: '65px'
  }
]

export const saColumns = [
  {
    label: '批次编号',
    value: 'recordId',
    width: '120px'
  },
  {
    label: '姓名',
    value: 'sampleName',
    width: '80px'
  },
  {
    label: '手机号',
    value: 'samplePhone',
    width: '100px'
  },
  {
    label: '发送时间',
    value: 'sendTime',
    width: '150px'
  },
  {
    label: '接收时间',
    value: 'receiveTime',
    width: '150px'
  },
  {
    label: '推送状态',
    value: 'sendStatus',
    width: '80px'
  },
  {
    label: '是否打开',
    value: 'opened',
    width: '70px'
  },
  {
    label: '答卷状态',
    value: 'answerStatus',
    width: '85px'
  },
  {
    label: '答卷链接',
    value: 'qsnLink',
    width: '80px'
  }
]

export const recipientColumns = [
  {
    label: '姓名',
    value: 'name',
    width: '130px'
  },
  {
    label: '手机',
    value: 'phone',
    width: '500px'
  },
  {
    label: '操作',
    value: 'action',
    width: '80px'
  }
]

export const smsColumns = [
  {
    label: '模板内容',
    value: 'content',
    width: '600px'
  },
  {
    label: '选择模板',
    value: 'action',
    width: '100px',
    align: 'center'
  }
]

export const groupColumns = [
  {
    label: '姓名',
    value: 'name',
    width: '90px',
    fixed: true
  },
  {
    label: '手机',
    value: 'phone',
    width: '130px',
    fixed: true
  },
  {
    label: '邮箱',
    value: 'email',
    width: '150px'
  },
  {
    label: '性别',
    value: 'gender',
    width: '70px'
  },
  {
    label: '出生日期',
    value: 'birthDate',
    width: '100px'
  },
  {
    label: '年龄区间',
    value: 'ageRange',
    width: '100px'
  },
  {
    label: '居住地',
    value: 'local',
    width: '260px'
  },
  {
    label: '婚姻状况',
    value: 'marriage',
    width: '90px'
  },
  {
    label: '学历',
    value: 'schoolingRecord',
    width: '100px'
  },
  {
    label: '行业',
    value: 'industry',
    width: '120px'
  },
  {
    label: '月收入',
    value: 'income',
    width: '130px'
  },
  {
    label: '创建时间',
    value: 'createTime',
    width: '180px'
  }
]

export const smsTempStatus = {
  NO_REWARD: 1, // 无奖
  HAVE_REWARD: 2, // 有奖
  NORMAL: 3, // 普通
  COMPANY: 4, // 企业
  // 经纬
  JW30: 30,
  // 诚凯
  CK39: 39,
  // 清研
  QY1: 11,
  QY2: 12,
  QY4: 16,
  QY17: 17,
  QY26: 26,
  QY27: 27,
  QY28: 28,
  QY29: 29,
  QY31: 31,
  QY32: 32,
  QY33: 33,
  QY34: 34,
  QY35: 35,
  QY36: 36,
  QY37: 37,
  QY38: 38,
  QY40: 40,
  QY41: 41,
  QY42: 42,
  QY43: 43,
  QY44: 44,
  QY45: 45,
  QY46: 46,
  QY47: 47,
  QY48: 48,
  QY49: 49,
  QY50: 50,
  QY417: 417
}

export function getTempObjectFn(tempArr = []) {
  const prefix = 'smsTempText'
  const objFn = {}
  for (const tmp of tempArr) {
    const { id, baseContent } = tmp
    const contentStr = baseContent || ''
    const variablies = contentStr.match(/\$\[\w+\]|\$\{\w+\}/g) || []
    objFn[`${prefix}${id}`] = args => {
      if (variablies.length === 0) return contentStr
      const params = args || {}
      let resultStr = contentStr
      for (const vStr of variablies) {
        const vKey = vStr.replace(/[\$\{\}\[\]]/g, '')
        const valueStr = params[vKey] === undefined ? `$[${vKey}]` : params[vKey]
        resultStr = resultStr.replace(vStr, valueStr)
      }
      return resultStr
    }
  }
  return objFn
}

export const confirmSendColumns = [
  {
    label: '内容字符数',
    value: 'contentSize',
    width: '20%',
    headName: 'contentHeader'
  },
  {
    label: '计费条数',
    value: 'billCount',
    width: '20%'
  },
  {
    label: '收信人数量',
    value: 'recipientSize',
    width: '20%'
  },
  {
    label: '短信单价（元）',
    value: 'smsUnitPrice',
    width: '20%'
  },
  {
    label: '合计（元）',
    value: 'total',
    width: '20%'
  }
]
